export const CERTIFICATION_REVIEW_STATUS = {
  UNDER_REVIEW: 'UNDER_REVIEW',
  REVOKED: 'REVOKED',
  NOT_REQUIRED: 'NOT_REQUIRED',
  REVIEW_APPROVED: 'REVIEW_APPROVED',
} as const;

export type CERTIFICATION_REVIEW_STATUS =
  (typeof CERTIFICATION_REVIEW_STATUS)[keyof typeof CERTIFICATION_REVIEW_STATUS];

export const CERTIFICATION_BANNED_MESSAGE =
  "You're temporarily restricted from purchasing certifications due to a policy violation.";

export const CERTIFICATION_PERMANENTLY_BANNED_MESSAGE =
  'Your access has been permanently revoked due to a policy violation. This includes all remaining attempts.';

export const CERTIFICATION_REVIEW_MESSAGE: Partial<Record<CERTIFICATION_REVIEW_STATUS, string>> = {
  [CERTIFICATION_REVIEW_STATUS.UNDER_REVIEW]: 'This certification is under review',
  [CERTIFICATION_REVIEW_STATUS.REVOKED]:
    'This certification was revoked due to a violation of our anti-cheating policy.',
};
